module.exports = __webpack_public_path__ + "img/9.ce5a162d.jpg";